<template>
  <div v-show="visible && !$parent.inMeeting">
    <!-- <b-alert
      :show="mediaError"
      variant="danger"
      dismissible
      @dismissed="$router.go(-1)"
    >
      {{ $t('CONFIGURE.MEDIA_ERROR') }}
    </b-alert> -->
    <b-alert
      :show="mediaPermission"
      variant="danger"
      dismissible
    >
      Please grant permissions to use your camera/microphone
    </b-alert>
    <b-row align-h="center">
      <b-col
        cols="12"
        md="8"
        lg="6">
        <div class="text-center mt-3">
          <h3>{{ $t('CONFIGURE.WELCOME_TITLE') + " " + userName }}</h3>
        </div>
        <div class="rounded embed-responsive embed-responsive-16by9">
          <video
            v-if="cameraOn && media && media.getVideoTracks()[0] && !$parent.inMeeting"
            ref="testVideo"
            :src-object.prop.camel="media"
            :style="computeVideoElementStyle()"
            class="rounded embed-responsive-item"
            autoplay="true"
            playsinline
          />
          <div
            v-if="!cameraOn && !$parent.inMeeting"
            class="rounded embed-responsive-item">
            <h3 class="camera-off">{{ userName }}</h3>
          </div>
          <div class="bottom-bar"/>
        </div>
        <div class="controls abs-middle">
          <span
            id="settings"
            class="d-none d-sm-inline-block"
            href="#"
            tabindex="0"
            @click="refreshDevices()">
            <cog-icon
              :size="35"
              class=""/>
            <span class="d-block">
              <b>{{ $t('CONFIGURE.SETTINGS_BUTTON') }}</b>
            </span>
            <div
              v-if="audioError"
              class="helpBlock">
              {{ $t('CONFIGURE.HELPBLOCK_UNSUPPORTED') }}
              <div class="d-flex justify-content-between pt-2">
                <button
                  class="btn-sm btn btn-primary-light"
                  @click="toggleAudioList">{{ $t('CONFIGURE.SELECT_DEVICE') }}</button>
                <button
                  class="btn-sm btn btn-primary-light"
                  @click="changeAudioInput('default'); audioError=false">{{ $t('CONFIGURE.USE_DEFAULT') }}</button>
              </div>
            </div>
            <div
              v-if="videoError"
              class="helpBlock">
              {{ $t('CONFIGURE.HELPBLOCK_UNSUPPORTED_VIDEO') }}
              <div class="d-flex pt-2">
                <button
                  class="btn-sm btn btn-primary-light"
                  @click="toggleVideoList">{{ $t('CONFIGURE.SELECT_DEVICE') }}</button>
              </div>
            </div>
          </span>
          <span @click="cameraOn = !cameraOn">
            <video-icon
              v-if="cameraOn"
              id="video"
              :size="35"
              class=""
            />
            <video-off-icon
              v-else
              id="video-off"
              :size="35"
              class="muted"/>
            <span
              v-if="cameraOn"
              class="d-block">
              <b>{{ $t('CONFIGURE.STOP_VIDEO') }}</b>
            </span>
            <span
              v-else
              class="d-block">
              <b>{{ $t('CONFIGURE.START_VIDEO') }}</b>
            </span>
          </span>
          <span @click="miceOn = !miceOn">
            <microphone-icon
              v-if="miceOn"
              id="mic"
              :size="35"
              class=""/>
            <microphone-off-icon
              v-else
              id="mic-off"
              :size="35"
              class="muted"/>
            <span
              v-if="miceOn"
              class="d-block">
              <b>{{ $t('CONFIGURE.MUTE_ME') }}</b>
            </span>
            <span
              v-else
              class="d-block">
              <b>{{ $t('CONFIGURE.UNMUTE_ME') }}</b>
            </span>
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row
    align-h="center">
      <b-col
        cols="12"
        md="8"
        lg="6">
        <div
        class="mt-4 d-sm-flex text-center">
          <b-form-checkbox
          v-model="directly">
            <span class="fs14">{{ $t('CONFIGURE.SKIP') }}</span>
          </b-form-checkbox>
          <b-button
            v-if="joinBtnVisible"
            class="ml-sm-auto mt-4 mt-sm-0 join-button"
            variant="primary"
            @click="joinMeeting()"
          >
            {{ $t('CONFIGURE.BUTTON_JOINCONF') }}
          </b-button>
        </div>
      </b-col>
    </b-row>
    <b-popover
      ref="settings"
      target="settings"
      triggers="focus"
      placement="left">
      <ul class="list-unstyled setting-list pants">
        <li
          class="d-flex position-relative"
          @click.stop="toggleVideoList()">
          <video-icon
            :size="20"
            class="mr-2 middle middleish"/>
          <span
            v-for="device in videoDevices.filter(videoDevice => videoDevice.deviceId === $parent.storedCameraSettings.deviceId)"
            :key="device.deviceId"> {{ device.label ? device.label : $t('CONFIGURE.UNKNOW_DEVICE') }}</span>
          <chevron-right-icon
            v-if="videoDevices.length >= 1"
            :size="24"
            class="ml-auto"/>
          <div
            ref="videoOptions"
            class="options subMenu rounded">
            <ul
            class="list-unstyled">
              <li
                v-for="device in videoDevices"
                :key="device.deviceId"
                class="d-flex"
                @click="changeVideoInput(device.deviceId)">
                <check-icon
                  v-if="device.deviceId === $parent.storedCameraSettings.deviceId"
                  :size="20"
                  class="pr-1"/>
                <span
                  v-else
                  class="spacer mr-1"/>
                {{ device.label ? device.label : $t('CONFIGURE.UNKNOW_DEVICE') }}
              </li>
            </ul>
          </div>
        </li>
        <li
          class="d-flex position-relative"
          @click.stop="toggleSpeakerList()">
          <volume-high-icon
            :size="20"
            class="mr-2 middle"/>
          <span
            v-for="device in audioOutputDevices.filter(audioDevice => audioDevice.deviceId === selectedSinkId && browser.chrome)"
            :key="device.deviceId"> {{ device.label ? device.label : $t('CONFIGURE.UNKNOW_DEVICE') }}</span>
          <span
          v-if="!browser.chrome"> {{ $t('CONFIGURE.DEFAULT_SPEAKERS') }} </span>
          <chevron-right-icon
            v-if="audioOutputDevices.length > 1"
            :size="24"
            class="ml-auto"/>
          <div
            ref="audioOutputOptions"
            class="options subMenu rounded">
            <ul
            class="list-unstyled">
              <li
                v-for="device in audioOutputDevices"
                :key="device.deviceId"
                class="d-flex"
                @click="changeAudioOutput(device.deviceId)">
                <check-icon
                  v-if="device.deviceId === selectedSinkId"
                  :size="20"
                  class="pr-1"/>
                <span
                  v-else
                  class="spacer mr-1"/>
                {{ device.label ? device.label : $t('CONFIGURE.UNKNOW_DEVICE') }}
              </li>
            </ul>
          </div>
        </li>
        <li
          class="d-flex position-relative"
          @click.stop="toggleAudioList()">
          <microphone-icon
            :size="20"
            class="mr-2 middle"/>
          <!-- <div class="d-flex flex-column"> -->
          <span
            v-for="device in audioDevices.filter(audioDevice => audioDevice.deviceId === $parent.storedMicSettings.deviceId)"
            :key="device.deviceId"
            class="d-flex">{{ device.label ? device.label : $t('CONFIGURE.UNKNOW_DEVICE') }}</span>
          <!-- <volume-indicator
            :display="true"
            :media="media"
            class="d-flex volume"
          />
          </div> -->
          <chevron-right-icon
            v-if="audioDevices.length > 1"
            :size="24"
            class="ml-auto"/>
          <div
            ref="audioOptions"
            class="subMenu options rounded">
            <ul class="list-unstyled">
              <li
                v-for="device in audioDevices"
                :key="device.deviceId"
                @click="changeAudioInput(device.deviceId)">
                <check-icon
                  v-if="device.deviceId === $parent.storedMicSettings.deviceId"
                  :size="20"
                  class="pr-1"/>
                <span
                  v-else
                  class="spacer mr-1"/>
                {{ device.label ? device.label : $t('CONFIGURE.UNKNOW_DEVICE') }}
              </li>
            </ul>
          </div>
        </li>
        <hr>
        <li>
          <span @click="refreshDevices()">
            <refresh-icon
              :size="20"
              class="mr-2 middle"/>
          {{ $t('CONFIGURE.REFRESH_DEVICES') }}</span>
        </li>
      </ul>
    </b-popover>
  </div>
</template>

<script>
import {getBrowser} from "../functions/browserDetails"
import {loadStorageData, getItem, setItem, isDebug} from "../functions/storageManager"
import {parseJwt} from "../functions/globalMethods"
import {ref, reactive, watch, onMounted} from "@vue/composition-api"
import CogIcon from "icons/Cog"
import RefreshIcon from "icons/Refresh"
import MicrophoneIcon from "icons/Microphone"
import MicrophoneOffIcon from "icons/MicrophoneOff"
import VideoIcon from "icons/Video"
import VideoOffIcon from "icons/VideoOff"
import CheckIcon from "icons/Check"
import ChevronRightIcon from "icons/ChevronRight"
import VolumeHighIcon from "icons/VolumeHigh"
import VolumeIndicator from "./VolumeIndicator";

export default {
  name: 'ConfigureDevicesJitsi',
  components: {
    VolumeIndicator,
    CogIcon,
    MicrophoneIcon,
    MicrophoneOffIcon,
    ChevronRightIcon,
    VideoIcon,
    VideoOffIcon,
    RefreshIcon,
    VolumeHighIcon,
    CheckIcon
  },
  setup(props, context) {
    const audioDevices = reactive([])
    const videoDevices = reactive([])
    const audioOutputDevices = reactive([])
    const selectedSinkId = ref('')
    const visible = ref(true)
    const meetingData = ref({})
    const directly = ref(false)
    const joinBtnVisible = ref(true)
    const browser = ref(null)
    const userName = ref("")
    const mediaPermission = ref(false)

    loadStorageData()

    if (getItem('meetingData') !== undefined) {
      meetingData.value = getItem('meetingData')
    }

    if (getItem('directly') !== undefined) {
      directly.value = getItem('directly')
    }

    if (getItem('language') !== undefined) {
      context.root.$i18n.locale = getItem('language')
    } else if (context.root.$route.query.language) {
      context.root.$i18n.locale = context.root.$route.query.language
    } else if (window.default_language !== "") {
      context.root.$i18n.locale = window.default_language
    }

    let audio_constraints = {
      echoCancellation: true,
      deviceId: {exact: undefined}
    }
    let video_constraints = {
      deviceId: {exact: undefined}
    }
    let supports = navigator.mediaDevices.getSupportedConstraints()
    if (supports['frameRate']) {
      video_constraints['frameRate'] = {min: 10, ideal: 30, max: 30}
    }
    const media = ref(new MediaStream())
    const miceOn = ref(true)
    const cameraOn = ref(true)
    const mediaError = ref(false)
    const audioError = ref(false)
    const videoError = ref(false)
    let disableCameraOn = ref(false)
    let enabledMice = ref(false)
    browser.value = getBrowser()
    userName.value = context.root.$route.query.name ? context.root.$route.query.name : meetingData.value.name
    if (context.parent.meta_token) {
      let token = parseJwt(context.parent.meta_token)
      userName.value = token.context.user.name
    }

    async function configureDevices() {
      getStorageData()
      if (context.root.$route.query.directly === 'true' || context.root.$route.query.directly === true)
        visible.value = false
      if (isDebug('info')) context.root.$notify.info('configureDevices')
      await refreshDevices().catch(e => console.log(e))
      await initDevices()
      await refreshDevices().catch(e => console.log(e))
      if (context.parent.storedMicSettings.deviceId != null && context.parent.storedMicSettings.label == '' && audioDevices.length >=0) {
        let foundDevice = audioDevices.find( E => {
          return E.kind == 'audioinput' && E.deviceId == context.parent.storedMicSettings.deviceId
        })
        if (foundDevice !== undefined) {
          context.parent.storedMicSettings = foundDevice
          setItem('micSelected', foundDevice)
        }
      } else if (context.parent.storedMicSettings.deviceId == null && audio_constraints.deviceId.exact){
        let foundDevice = audioDevices.find( E => {
          return E.kind == 'audioinput' && E.deviceId == audio_constraints.deviceId.exact
        })
        if (foundDevice !== undefined) {
          context.parent.storedMicSettings = foundDevice
          setItem('micSelected', foundDevice)
        }
      }

      if (context.parent.storedCameraSettings.deviceId != null && context.parent.storedCameraSettings.label == '' && videoDevices.length >=0) {
        let foundDevice = videoDevices.find( E => {
          return E.kind == 'videoinput' && E.deviceId == context.parent.storedCameraSettings.deviceId
        })
        if (foundDevice !== undefined) {
          context.parent.storedCameraSettings = foundDevice
          setItem('cameraSelected', foundDevice)
        }
      } else if (context.parent.storedCameraSettings.deviceId == null && video_constraints.deviceId.exact) {
        let foundDevice = videoDevices.find( E => {
          return E.kind == 'videoinput' && E.deviceId == video_constraints.deviceId.exact
        })
        if (foundDevice !== undefined) {
          context.parent.storedCameraSettings = foundDevice
          setItem('cameraSelected', foundDevice)
        }
      }

      if (context.parent.storedSpeakerSettings && browser.value.chrome){
        let device = audioOutputDevices.find(device => device.deviceId === context.parent.storedSpeakerSettings.deviceId)
        if(device) {
          selectedSinkId.value = device.deviceId;
        } else {
          console.log('Output device no longer available going to default');
          selectedSinkId.value = audioOutputDevices[0].deviceId
        }
      } else if (audioOutputDevices.length > 0) {
        console.log('First Time here set it to default');
        selectedSinkId.value = audioOutputDevices[0].deviceId
      }

      if (!browser.value.chrome)
        selectedSinkId.value = "default"

      if (visible.value == false) {
        if (media.value) {
          media.value.getTracks().forEach((track) => {
            track.stop()
            media.value.removeTrack(track)
          })
        }
      }
      joinBtnVisible.value = true
    }

    async function refreshDevices() {
      let devices = await navigator.mediaDevices.enumerateDevices().catch(e => console.log(e))
      audioDevices.splice(0, audioDevices.length)
      videoDevices.splice(0, videoDevices.length)
      audioOutputDevices.splice(0, audioOutputDevices.length)
      devices.forEach((E) => {
        if (E.kind === 'videoinput') {
          // let index = videoDevices.findIndex(el => el.deviceId === E.deviceId)
          // if (index < 0) {
          videoDevices.push({deviceId: E.deviceId, groupId: E.groupId, kind: E.kind, label: E.label})
          /* } else {
            videoDevices.splice(index, 1, {deviceId: E.deviceId, groupId: E.groupId, kind: E.kind, label: E.label})
          } */
        } else if (E.kind === 'audioinput') {
          // let index = audioDevices.findIndex(el => el.deviceId === E.deviceId)
          // if (index < 0) {
          audioDevices.push({deviceId: E.deviceId, groupId: E.groupId, kind: E.kind, label: E.label})
          /* } else {
            audioDevices.splice(index, 1, {deviceId: E.deviceId, groupId: E.groupId, kind: E.kind, label: E.label})
          } */
        } else if (E.kind === 'audiooutput') {
          // let index = audioOutputDevices.findIndex(el => el.deviceId === E.deviceId)
          // if (index < 0) {
          audioOutputDevices.push({deviceId: E.deviceId, groupId: E.groupId, kind: E.kind, label: E.label})
          /* } else {
            audioOutputDevices.splice(index, 1, {deviceId: E.deviceId, groupId: E.groupId, kind: E.kind, label: E.label})
          } */
        }
      })
    }

    function getStorageData() {
      getItem('miceOn') !== undefined ? miceOn.value = getItem('miceOn') : setItem('miceOn', miceOn.value)
      getItem('cameraOn') !== undefined ? cameraOn.value = getItem('cameraOn') : setItem('cameraOn', cameraOn.value)
      if (getItem('directly') !== undefined) visible.value = !getItem('directly')
      if (!!navigator.userAgent.match(/iPhone|iPad|iPod/i)) {
        return
      } else {
        if (getItem('micSelected') !== undefined) audio_constraints.deviceId.exact = getItem('micSelected').deviceId
        if (getItem('cameraSelected') !== undefined) video_constraints.deviceId.exact = getItem('cameraSelected').deviceId
        if (getItem('speakerSelected') !== undefined) context.parent.storedSpeakerSettings =getItem('speakerSelected')
      }
    }

    async function changeAudioDevice() {
      let constraints = {
        audio: audio_constraints,
        video: false
      }
      if (media.value) {
        let track = media.value.getAudioTracks()[0]
        if (track) {
          track.stop()
          media.value.removeTrack(track)
        }
      }
      let mediaStream = await navigator.mediaDevices.getUserMedia(constraints).catch((error) => {
        //context.root.$notify.error(context.root.$t("CONFIGURE.MEDIA_AUDIOERROR") + error, {visibility: 10000, closeButtonClass:'close'})
        if (error.name === 'NotAllowedError') { // its disabled and it needs more help
          mediaError.value = true
        } else {
          audioError.value = true
        }
        audio_constraints.deviceId.exact = null
        context.parent.storedMicSettings.deviceId = null
        context.parent.storedMicSettings.groupId = null
        context.parent.storedMicSettings.label = ''
        setItem('micSelected', context.parent.storedMicSettings)
      })
      if (mediaStream) {
        mediaError.value = false
        if (media.value) {
          media.value.addTrack(mediaStream.getAudioTracks()[0])
        } else {
          media.value = mediaStream
        }
        media.value.getAudioTracks()[0].enabled = false
        audio_constraints.deviceId.exact = media.value.getAudioTracks()[0].getSettings().deviceId || media.value.getAudioTracks()[0].getConstraints().deviceId
        let foundDevice = audioDevices.find( E => {
          return E.kind == 'audioinput' && E.deviceId == audio_constraints.deviceId.exact
        })
        if (foundDevice !== undefined) {
          context.parent.storedMicSettings = foundDevice
          setItem('micSelected', foundDevice)
        }
      } else {
        miceOn.value = false
        if (audioDevices.length >=1)
          audioError.value = true
        audio_constraints.deviceId.exact = null
        context.parent.storedMicSettings.deviceId = null
        context.parent.storedMicSettings.groupId = null
        context.parent.storedMicSettings.label = ''
        setItem('micSelected', context.parent.storedMicSettings)
      }
    }

    async function changeVideoDevice() {
      let constraints = {
        audio: false,
        video: video_constraints
      }
      if (media.value) {
        media.value.getVideoTracks().forEach((track) => {
          track.enabled = false
          track.stop()
          media.value.removeTrack(track)
        })
      }
      let mediaStream = await navigator.mediaDevices.getUserMedia(constraints).catch((error) => {
        context.root.$notify.error(context.root.$t("CONFIGURE.MEDIA_VIDEOERROR") + error)
        if (error.name === 'NotAllowedError') {
          mediaError.value = true
        } else {
          if (videoDevices >=1)
            videoError.value = true
        }
        video_constraints.deviceId.exact = null
        context.parent.storedCameraSettings.deviceId = null
        context.parent.storedCameraSettings.groupId = null
        context.parent.storedCameraSettings.label = ''
        setItem('cameraSelected', context.parent.storedCameraSettings)
      })
      if (mediaStream) {
        mediaError.value = false
        disableCameraOn.value = false
        if (media.value) {
          media.value.addTrack(mediaStream.getVideoTracks()[0])
        } else {
          media.value = mediaStream
        }
        media.value.getVideoTracks()[0].enabled = true
        video_constraints.deviceId.exact = media.value.getVideoTracks()[0].getSettings().deviceId || media.value.getVideoTracks()[0].getConstraints().deviceId
        let foundDevice = videoDevices.find( E => {
          return E.kind == 'videoinput' && E.deviceId == video_constraints.deviceId.exact
        })
        if (foundDevice !== undefined) {
          context.parent.storedCameraSettings = foundDevice
          setItem('cameraSelected', foundDevice)
        }
      } else {
        disableCameraOn.value = true
        cameraOn.value = false
        if (videoDevices.length >=1)
          videoError.value = true
        video_constraints.deviceId.exact = null
        context.parent.storedCameraSettings.deviceId = null
        context.parent.storedCameraSettings.groupId = null
        context.parent.storedCameraSettings.label = ''
        setItem('cameraSelected', context.parent.storedCameraSettings)
      }
    }

    async function initDevices() {
      joinBtnVisible.value = false
      let constraints = {audio: audio_constraints, video: video_constraints}
      if (media.value) {
        media.value.getTracks().forEach((track) => {
          track.stop()
          media.value.removeTrack(track)
        })
      }
      media.value = await navigator.mediaDevices.getUserMedia(constraints).catch((error) => {
        //context.root.$notify.error(context.root.$t("CONFIGURE.MEDIA_DEVICEERROR") + error)
        console.log(context.root.$t("CONFIGURE.MEDIA_DEVICEERROR") + error)
        if (error.name === 'NotAllowedError') {
          mediaError.value = true
        }
      })
      if (media.value) {
        mediaError.value = false
        disableCameraOn.value = false
        if (media.value.getAudioTracks().length > 0) {
          media.value.getAudioTracks()[0].enabled = false
          audio_constraints.deviceId.exact = media.value.getAudioTracks()[0].getSettings().deviceId || media.value.getAudioTracks()[0].getConstraints().deviceId
          let foundDevice = audioDevices.find( E => {
            return E.kind == 'audioinput' && E.deviceId == audio_constraints.deviceId.exact
          })
          if (foundDevice !== undefined) {
            context.parent.storedMicSettings = foundDevice
            setItem('micSelected', foundDevice)
          }
        }
        if (media.value.getVideoTracks().length > 0) {
          media.value.getVideoTracks()[0].enabled = true
          video_constraints.deviceId.exact = media.value.getVideoTracks()[0].getSettings().deviceId || media.value.getVideoTracks()[0].getConstraints().deviceId
          let foundDevice = videoDevices.find( E => {
            return E.kind == 'videoinput' && E.deviceId == video_constraints.deviceId.exact
          })
          if (foundDevice !== undefined) {
            context.parent.storedCameraSettings = foundDevice
            setItem('cameraSelected', foundDevice)
          }
        }
      } else {
        disableCameraOn.value = true
        cameraOn.value = false
        miceOn.value = false
        await changeAudioDevice().catch(e => console.log(e))
        await changeVideoDevice().catch(e => console.log(e))
      }
      if (browser.value.chrome) {
        let cameraPerm = await navigator.permissions.query({name:'camera'})
        if (cameraPerm.state === 'denied') {
          mediaPermission.value = true
        }
        let micPerm = await await navigator.permissions.query({name:'microphone'})
        if (micPerm.state === 'denied') {
          mediaPermission.value = true
        }
      }
    }

    function changeVideoInput(id) {
      videoError.value = false
      /* context.parent.storedCameraSettings = videoDevices.value.find( E => {
        return E.kind == 'videooinput' && E.deviceId == id
      })
      if (context.parent.storedCameraSettings)
        setItem('cameraSelected', context.parent.storedCameraSettings) */
      if (video_constraints.deviceId.exact !== id) {
        video_constraints.deviceId.exact = id
        changeVideoDevice()
      }
      context.refs.settings.$emit('close')
      //videoError.value = false
    }

    function changeAudioInput(id) {
      audioError.value = false
      /* context.parent.storedMicSettings = audioDevices.value.find( E => {
        return E.kind == 'audioinput' && E.deviceId == id
      })
      if (context.parent.storedMicSettings)
        setItem('micSelected', context.parent.storedMicSettings) */
      if (audio_constraints.deviceId.exact !== id) {
        audio_constraints.deviceId.exact = id
        changeAudioDevice()
      }
      context.refs.settings.$emit('close')
    }


    function changeAudioOutput(id){
      if (browser.value.chrome) {
        context.parent.storedSpeakerSettings = audioOutputDevices.find( E => {
          setItem('speakerSelected', E)
          return E.kind == 'audiooutput' && E.deviceId == id
        })
        if (context.parent.storedSpeakerSettings)
          setItem('speakerSelected', context.parent.storedSpeakerSettings)
        selectedSinkId.value = id
      }
      context.refs.settings.$emit('close')
    }

    function toggleVideoList() {
      if (videoDevices.length >= 1) {
        if (context.refs.videoOptions) context.refs.videoOptions.style.display = 'block'
        if (context.refs.audioOptions) context.refs.audioOptions.style.display = 'none'
        if (context.refs.audioOutputOptions) context.refs.audioOutputOptions.style.display = 'none'
      }
    }

    function toggleSpeakerList(){
      if (audioOutputDevices.length > 1) {
        if (context.refs.audioOutputOptions) context.refs.audioOutputOptions.style.display = 'block'
        if (context.refs.audioOptions) context.refs.audioOptions.style.display = 'none'
        if (context.refs.videoOptions) context.refs.videoOptions.style.display = 'none'
      }
    }

    function toggleAudioList() {
      if (audioDevices.length >= 1) {
        if (context.refs.audioOptions) context.refs.audioOptions.style.display = 'block'
        if (context.refs.videoOptions) context.refs.videoOptions.style.display = 'none'
        if (context.refs.audioOutputOptions) context.refs.audioOutputOptions.style.display = 'none'
      }
    }

    function joinMeeting() {
      visible.value = false
      if (media.value) {
        media.value.getTracks().forEach((track) => {
          track.stop()
          media.value.removeTrack(track)
        })
      }
      context.parent.joinJitsi()
    }

    function computeVideoElementStyle() {
      if (getItem('cameraMirror'))
        return {transform: "rotateY(180deg)"}
      else
        return {transform: "rotateY(0deg)"}
    }

    watch(cameraOn, (newVal, oldVal) => {
      if (oldVal != undefined) {
        setItem('cameraOn', newVal)
      }
    })
    watch(miceOn, (newVal, oldVal) => {
      if (oldVal != undefined) {
        setItem('miceOn', newVal)
      }
    })
    watch(directly, (newVal, oldVal) => {
      if (oldVal != undefined) {
        setItem('directly', newVal)
      }
    })


    return {
      visible,
      userName,
      media,
      miceOn,
      cameraOn,
      directly,
      mediaError,
      disableCameraOn,
      enabledMice,
      refreshDevices,
      configureDevices,
      initDevices,
      changeAudioInput,
      changeVideoInput,
      changeAudioOutput,
      loadStorageData,
      video_constraints,
      audio_constraints,
      getItem,
      toggleVideoList,
      toggleAudioList,
      toggleSpeakerList,
      supports,
      audioError,
      videoError,
      joinBtnVisible,
      computeVideoElementStyle,
      audioDevices,
      videoDevices,
      audioOutputDevices,
      getBrowser,
      browser,
      selectedSinkId,
      joinMeeting,
      mediaPermission
    }
  }
}
</script>
<style>
  @media (max-width: 575px) {
    .join-button {
      margin: auto;
    }
    .controls {
      width: 170px;
    }
  }
  .subMenu{
    left: 100%;
  }
  .audioList{
    height: 50px!important;
  }
  .audioList .material-design-icon {
    vertical-align: sub;
  }
  .middle{
    vertical-align: middle;
  }
  .middle.middleish{
    top: -2px
  }
  .audioList .volume{
    margin-top: 1px;
  }
  .spacer {
    display: inline-block;
    width: 20px;
  }
  .helpBlock {
    width: 250px;
    position: absolute;
    top: -100px;
    left: -108px;
    background: #FFFFFF;
    color: #282828;
    padding: 12px;
    border-radius: 4px;
  }
</style>



// WEBPACK FOOTER //
// src/components/ConfigureDevicesJitsi.vue